import { useState } from 'react';
import { LinkIcon } from 'lucide-react';

import Button from '@/components/Common/Button';
import {
  DialogHeader,
  DialogContent,
  DialogTitle,
  DialogTrigger,
  Dialog,
} from '@/components/ui/Dialog';
import ButtonGroup from '@/components/Common/ButtonGroup';
import { useCreateOfferLink, OfferLinkResponse } from '@/hooks/api/offerLinks';
import { ExperimentResponse } from '@/hooks/api/experiments';
import OfferLinkForm from './OfferLinkForm';

type CreateOfferLinkProps = {
  experiment: ExperimentResponse;
  onSuccess?: (offerLink: OfferLinkResponse) => void;
};

const CreateOfferLink = ({ experiment, onSuccess }: CreateOfferLinkProps) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [, createOfferLink] = useCreateOfferLink();

  return (
    <Dialog onOpenChange={setIsDialogOpen} open={isDialogOpen}>
      <DialogTrigger asChild>
        <ButtonGroup>
          <Button
            onClick={() => setIsDialogOpen(true)}
            size="small"
            icon={<LinkIcon size="1em" />}
          >
            Start linking an offer
          </Button>
        </ButtonGroup>
      </DialogTrigger>
      <DialogContent className="max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Link offer</DialogTitle>
        </DialogHeader>
        <OfferLinkForm
          experiment={experiment}
          saveOfferLink={createOfferLink}
          onSuccess={(values) => {
            setIsDialogOpen(false);
            onSuccess?.(values);
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default CreateOfferLink;
